import Employee from './Employee'
import Permission from './Permission'
import List from './List'

export {
  Permission,
  List
}
export default Employee



// WEBPACK FOOTER //
// ./app/pages/Employees/index.js